const ToolsData =
[
  {
    "id": 1, 
    "img": require("./tools/react.png"),
    "name": "React Js"
  },
  {
    "id": 20, 
    "img": require("./tools/redux.png"),
    "name": "Redux"
  },
  {
    "id": 13,
    "img": require("./tools/nextjs.png"),
    "name": "Next js"
  },
  {
    "id": 5,
    "img": require("./tools/express.png"),
    "name": "Express Js"
  },

  {
    "id": 3,
    "img": require("./tools/nest.png"),
    "name": "NestJs"
  },
  {
    "id": 10,
    "img": require("./tools/mongo.png"),
    "name": "MongoDB"
  },
  {
    "id": 11,
    "img": require("./tools/mysql.png"),
    "name": "MySQL"
  },
  {
    "id": 4,
    "img": require("./tools/css.png"),
    "name": "CSS"
  },

  {
    "id": 6,
    "img": require("./tools/firebasepng.png"),
    "name": "Firebase"
  },
  {
    "id": 7,
    "img":require("./tools/git.png"),
    "name": "Git & Github"
  },
  {
    "id": 8,
    "img": require("./tools/herokupng.png"),
    "name": "Heroku"
  },
  {
    "id": 9,
    "img": require("./tools/js.png"),
    "name": "Java Script"
  },

  {
    "id": 11,
    "img": require("./tools/mongoose.png"),
    "name": "Mongoose"
  },
  {
    "id": 12,
    "img": require("./tools/netly.png"),
    "name": "Netlify"
  },

  {
    "id": 15,
    "img": require("./tools/sass.png"),
    "name": "SASS"
  }, 
  {
    "id": 2,
    "img": require("./tools/bs.png"),
    "name": "Bootstrap"
  },
  {
    "id": 16,
    "img": require("./tools/tailwind.png"),
    "name": "Tailwind"
  },
  {
    "id": 19,
    "img": require("./tools/es6.png"),
    "name": "ES6"
  },
  {
    "id": 20,
    "img": require("./tools/ui.png"),
    "name": "Material UI"
  },
  {
    "id": 21,
    "img": require("./tools/sass.png"),
    "name": "SASS"
  }
  
]

export default ToolsData